module.exports = __webpack_public_path__ + "static/media/testimony3.f00af316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/testimony3.jpg
// module id = 277
// module chunks = 0